import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-gt.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-gt.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { debounceTime } from "rxjs";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { GautrainService } from "../../../../../shared/services/modules/gautrain.service";
import { ViewApplicationLocationGtConstants } from "./view-application-location-gt.constants";
let ViewApplicationLocationGtComponent = class ViewApplicationLocationGtComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appController;
    routerParamsService;
    recipientListService;
    changeDetectorRefs;
    mapService;
    gautrainService;
    requestStatusService;
    viewApplicationService;
    active;
    saveBtnPlaceholder = ViewApplicationLocationGtConstants.SAVE_BUTTON_PLACEHOLDER;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationGtConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationGtConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationGtConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationGtConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationGtConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationGtConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationGtConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationGtConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationGtConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationGtConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationGtConstants.ADDRESS_CONTROL;
    zoneControl = ViewApplicationLocationGtConstants.ZONE_CONTROL;
    ownerControl = ViewApplicationLocationGtConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationGtConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationGtConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationGtConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationGtConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationGtConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationGtConstants.ADDRESS_TEXT_PLACEHOLDER;
    zoneLabel = ViewApplicationLocationGtConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = ViewApplicationLocationGtConstants.ADD_ZONE_LABEL;
    ownerLabel = ViewApplicationLocationGtConstants.OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationGtConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owner";
    zones = [];
    mapComponent;
    application;
    isMapLoaded = false;
    missingOwnerErrMsg = ViewApplicationLocationGtConstants.MISSING_OWNER_IN_PROPERTY;
    getApplicationSetPropertiesObservableSubscription;
    selectedPropertySubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, appController, routerParamsService, recipientListService, changeDetectorRefs, mapService, gautrainService, requestStatusService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.gautrainService = gautrainService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    onBtnSaveClicked() {
        if (this.propertiesForm.valid) {
            const points = [];
            const properties = [];
            let ownerMissingInProperty = false;
            const propertiesArray = this.getProperties();
            for (const item of propertiesArray.controls) {
                const centroid = item.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                const owners = item.get("owners").value.recipients;
                if (owners.length > 0) {
                    owners.forEach((owner) => {
                        owner = RecipientUtils.removeRecipientProperties(owner);
                    });
                }
                else {
                    ownerMissingInProperty = true;
                    this.appController.showMessage(this.missingOwnerErrMsg, AlertType.Warning);
                    break;
                }
                let property = null;
                if (item.get("property") !== null && item.get("property").value !== null) {
                    property = item.get("property").value;
                    property.address = item.get("address").value;
                    property.allotment = item.get("allotment").value;
                    property.erfNumber = item.get("erfNo").value;
                    property.farmNumber = item.get("farmNo").value;
                    property.sgCode = item.get("sgCode").value;
                    property.subdivision = item.get("subdivision").value;
                    property.zonings = [];
                    property.owners = owners;
                }
                else {
                    property = {
                        address: item.get("address").value,
                        allotment: item.get("allotment").value,
                        erfNumber: item.get("erfNo").value,
                        farmNumber: item.get("farmNo").value,
                        isDummy: false,
                        sgCode: item.get("sgCode").value,
                        shape: geometryJSON,
                        subdivision: item.get("subdivision").value,
                        updateGeometry: false,
                        wkid: 102100,
                        zonings: [],
                        owners,
                    };
                }
                const propertyZonesArray = item.get("zones");
                propertyZonesArray.controls.forEach((zoneItem) => {
                    if (zoneItem.get("id") !== null && zoneItem.get("id").value !== null) {
                        const zone = {
                            id: zoneItem.get("id").value,
                            applicationId: zoneItem.get("applicationId").value,
                            applicationPropertyId: zoneItem.get("applicationPropertyId").value,
                            deleted: false,
                            zoning: zoneItem.get("zone").value.value,
                        };
                        property.zonings.push(zone);
                    }
                    else {
                        const zone = {
                            deleted: false, zoning: zoneItem.get("zone").value.value,
                        };
                        property.zonings.push(zone);
                    }
                });
                properties.push(property);
            }
            if (!ownerMissingInProperty) {
                const params = {
                    properties, applicationShape: `MULTIPOINT (${points.join(", ")})`, applicationWkid: 102100
                };
                this.getApplicationSetPropertiesObservableSubscription = this.gautrainService.getApplicationSetPropertiesObservable(this.application.id, params)
                    .subscribe(() => {
                    this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                }, error => {
                    this.appController.handleServerErrorMessage(ViewApplicationLocationGtConstants.STEP_TITLE, error, CRUDOperation.Update);
                });
            }
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveZoneClicked(propertyIndex, zoneIndex) {
        const controls = this.getZones(propertyIndex);
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked(propertyIndex) {
        const zonesControl = this.getZones(propertyIndex);
        const zoneGroup = new FormGroup({
            id: new FormControl(null),
            applicationId: new FormControl(null),
            applicationPropertyId: new FormControl(null),
            zone: new FormControl(null, [Validators.required]),
            deleted: new FormControl(null)
        });
        zonesControl.push(zoneGroup);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.active = 0;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and name eq 'Zoning'`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe((response) => {
            this.onGetLookupsCompleted(response);
            this.getApplicantData();
        }, (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationLocationGtConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.changeDetectorRefs.detectChanges();
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
            if (this.aflaModuleStrategyService.lookups.has("zones")) {
                this.zones = this.aflaModuleStrategyService.lookups.get("zones");
                this.getApplicantData();
            }
            else {
                this.getLookups();
            }
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `properties($expand=zonings,owners($expand=groups))`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe((returnValue) => {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = returnValue.value[0];
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    buildingUse: new FormControl(property.buildingUse),
                    erfSize: new FormControl(property.erfSize, [Validators.required]),
                    buildingFloorArea: new FormControl(property.buildingFloorArea, [Validators.required]),
                    titleDeed: new FormControl(property.titleDeed, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    zones: new FormArray([], [Validators.min(1)]),
                    owners: new FormControl({ recipients: [] }, [Validators.required])
                });
                const zonesControl = newProperty.get("zones");
                property.zonings.forEach((zone) => {
                    this.zones.forEach(zoneOption => {
                        if (zoneOption.value === zone.zoning) {
                            const zoneGroup = new FormGroup({
                                id: new FormControl(zone.id),
                                applicationId: new FormControl(zone.applicationId),
                                applicationPropertyId: new FormControl(zone.applicationPropertyId),
                                zone: new FormControl(zoneOption, [Validators.required]),
                                deleted: new FormControl(zone.deleted)
                            });
                            zonesControl.push(zoneGroup);
                        }
                    });
                });
                const ownersControl = newProperty.get("owners");
                this.recipientListService.setRecipients(property.owners, false, ownersControl);
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.viewApplicationService.getTrueCentroid(url, formData)
                    .subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.updateRequiredFields(propertyControl.length - 1);
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                        this.changeDetectorRefs.detectChanges();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationGtConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.requestStatusService.showBusySpinner("GetPropertyDate");
                const sgCode = this.propertyDataAlternateColumnName(property.attributes, "SgCode", "sgcode");
                let found = false;
                this.getProperties().controls.forEach(item => {
                    const check = item.get("sgCode").value;
                    if (check === sgCode) {
                        found = true;
                        this.appController.showMessage(ViewApplicationLocationGtConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    }
                });
                if (!found) {
                    const newProperty = new FormGroup({
                        erfNo: new FormControl(this.propertyDataAlternateColumnName(property.attributes, "ErfNo", "erfno"), [Validators.required]),
                        subdivision: new FormControl(this.propertyDataAlternateColumnName(property.attributes, "PtnNum", "ptnnum"), [Validators.required]),
                        allotment: new FormControl(this.propertyDataAlternateColumnName(property.attributes, "Allotment", "allotment"), [Validators.required]),
                        farmNo: new FormControl(this.propertyDataAlternateColumnName(property.attributes, "FarmNo", "farmno"), [Validators.required]),
                        sgCode: new FormControl(sgCode, [Validators.required]),
                        address: new FormControl(this.propertyDataAlternateColumnName(property.attributes, "Address", "address"), [Validators.required]),
                        geometry: new FormControl(property.geometry),
                        centroid: new FormControl(null, [Validators.required]),
                        zones: new FormArray([], [Validators.min(1)]),
                        owners: new FormControl(null, [Validators.required])
                    });
                    const proxyUrl = ApiProxyConstants.URL;
                    const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                    const url = `${proxyUrl}?${gpToolUrl}`;
                    const formData = new FormData();
                    formData.append("f", "json");
                    formData.append("geometryJSON", JSON.stringify(property.geometry));
                    this.viewApplicationService.getTrueCentroid(url, formData)
                        .subscribe((response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property zone");
                        if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
                            const zoningLayer = zoningLayerObj.layer;
                            const zoningQuery = new Query();
                            zoningQuery.where = `SgCode = '${sgCode}'`;
                            zoningQuery.returnGeometry = false;
                            zoningQuery.outFields = ["*"];
                            zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                                // Make sure the grave centroid is within one cemetery boundary
                                const zonesControl = newProperty.get("zones");
                                if (zoneFeatureSet.features.length > 0) {
                                    zoneFeatureSet.features.forEach(item => {
                                        const zone = this.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                                        if (zone !== undefined && zone != null) {
                                            let foundZone = null;
                                            this.zones.forEach(zoneItem => {
                                                if (zoneItem.value === zone) {
                                                    foundZone = zoneItem;
                                                }
                                            });
                                            if (foundZone !== null) {
                                                zonesControl.push(new FormGroup({
                                                    zone: new FormControl(foundZone, [Validators.required])
                                                }));
                                            }
                                            else {
                                                this.appController.showMessage(ViewApplicationLocationGtConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Error);
                                                const params = {
                                                    moduleId: this.moduleID, lookupType: "Zoning", lookupList: [zone]
                                                };
                                                this.viewApplicationService.sendMissingLookupsEmail(params).subscribe();
                                            }
                                        }
                                        else {
                                            this.appController.showMessage(ViewApplicationLocationGtConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                                        }
                                    });
                                }
                                if (zonesControl.length === 0) {
                                    zonesControl.push(new FormGroup({
                                        zone: new FormControl(null, [Validators.required])
                                    }));
                                }
                                this.getPropertyOwners(sgCode, newProperty);
                            }, (zoningError) => {
                                this.appController.showMessage(zoningError.message, AlertType.Error);
                                this.getPropertyOwners(sgCode, newProperty);
                            });
                        }
                        else {
                            this.getPropertyOwners(sgCode, newProperty);
                        }
                    }, (error) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                        this.appController.handleServerErrorMessage(ViewApplicationLocationGtConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    });
                }
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(ViewApplicationLocationGtConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                this.recipientListService.setRecipients(owners, false, ownersControl);
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Town planning graphics", true);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: GautrainService },
        { type: RequestStatusService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationGtComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-gt",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationGtComponent);
export { ViewApplicationLocationGtComponent };
